export enum PageType {
  SignIn = 1, // 登录注册
  ForgotPassword = 2, // 忘记密码
  PhoneSignIn = 3, // 手机号登录注册
  PhoneVerification = 4, // 输入手机号验证码
}

export enum Action {
  None = 0, // 无
  EmailSignIn = 1, // 邮箱登录
  ThirdPartLogin = 2, // 第三方登录
  EmailRegister = 3, // 邮箱注册
  ForgotPassword = 4, // 忘记密码
  PhoneSignIn = 5, // 手机登录
  PhoneRegister = 6, // 手机注册
  Back = 7, // 回退
}

// 回退状态机，设置不同页面回退的目的页面
export const BackTypesStateMachine = {
  [PageType.PhoneVerification]: PageType.PhoneSignIn,
  [PageType.PhoneSignIn]: PageType.SignIn,
  [PageType.ForgotPassword]: PageType.SignIn,
  [PageType.SignIn]: null
}

export enum RegisterType {
  AUTO = 11, // 自动注册, APP端
  AUTO_REGISTER_EMAIL = 14 // 自动注册邮箱, PC端
}
export enum ActionType {
  Auto = 1, // 检测
  Login = 2, // 登录
  Register = 3, // 注册
  RegisterAutoLogin = 4 // 注册自动登录
}